<template>
    <div class="checklist-template-index">
        <transition mode="out-in">
            <div class="mt-4 grid grid-cols-8 grid-flow-row gap-4">
                <div class="col-span-8 p-4 relative border-2 rounded-lg">
                        <p class="inline-block text-gray-600 text-base font-bold mr-2">Inventory Settings</p>
                        <el-form label-position="top" size="small">
                            <div class="col-span-12 mt-2 md:col-span-6 lg:col-span-4">
                                <div v-if="!featurePermissions['featureEnabledInventoryManagement']">
                                    <h1>Upgrade Required</h1>
                                    <p>
                                        To enable Inventory features, you'll need to upgrade your plan. Please contact Hera
                                        Support by chatting with us below.
                                    </p>
                                </div>
                                <div v-else>
                                    <div>Enable Inventory for {{ userInfo.tenant.companyName }}</div>
                                    <el-switch
                                        :class="{'switch-loading': permissionInventory.loading}"
                                        v-model="permissionInventory.value"
                                        active-color="#13ce66"
                                        :disabled="disabledPermissionInventory"
                                        @change="toggleInventoryFeature">
                                    </el-switch>
                                </div>
                            </div>
                        </el-form>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { getTenantFeaturePermissions } from '@/middlewares/permissions';
import { updateTenantDetail } from '@/store/mutations';
import { mapGetters, mapState } from 'vuex';

export default{
    name: "InventorySettings",
    data(){
        return {
            permissionInventory: {
                loading :false,
                value:false
            }
        }
    },
    beforeMount() {
        this.permissionInventory.value = this.userInfo?.tenant?.permissionInventoryManagement;
    },
    computed: {
        ...mapState(['userInfo']),
        ...mapGetters(['isSystemAdmin']),
        disabledPermissionInventory(){
            if(!this.featurePermissions.featureEnabledInventoryManagement){
                return true
            }
            if(this.userInfo.permissionFullAccess || this.isSystemAdmin){
                return false
            }
            return true
        },
        featurePermissions(){
            return getTenantFeaturePermissions()
        }
    },
    methods: {
        async toggleInventoryFeature(value){
            this.permissionInventory.loading = true
            try {
                const updated = await this.updatePermissionInventory(value)
                this.permissionInventory.value = updated.permissionInventoryManagement
            } catch (error) {
                this.displayUserError(error)
                this.permissionInventory.value = !value
            }
            this.permissionInventory.loading = false
        },
        async updatePermissionInventory(value){
            const input = {
                id: this.userInfo.tenant.id,
                permissionInventoryManagement: value
            }
            const response = await this.api(updateTenantDetail, { input })
            return response.data.updateTenant
        }
    }
}
</script>
<style lang="scss">
.checklist-template-index{
    .switch-loading{
        .el-switch__core::after {
            content: "";
            position: absolute;
            border: 2px solid theme('colors.blue.500');
            border-top-color: transparent;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }
    }
}
@keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
}
</style>